import { useQuery } from '@apollo/client';
import { Table, Typography } from '@otp/ui';
import { MembersAssigned } from '@otp/icons';
import {
  SortingDirection,
  StoreModel,
  UsersWithPrimaryStoresDocument,
  UsersWithPrimaryStoresQuery,
} from 'src/graphql/generated/graphql';
import { getAssignedOTPsTableConfig } from './otps-assigned-list-config';
import { useTranslation } from 'react-i18next';

type OTPsAssignedListProps = {
  store: Partial<StoreModel>;
};

export const OTPsAssignedList = ({ store }: OTPsAssignedListProps) => {
  const { t } = useTranslation();
  const { loading, data } = useQuery<UsersWithPrimaryStoresQuery>(
    UsersWithPrimaryStoresDocument,
    {
      variables: {
        filter: {
          assignedToStoreId: store.id,
        },
        sorting: {
          lastName: SortingDirection.Asc,
        },
      },
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-and-network',
    },
  );

  const getIsCurrentStoreAmongPrimary = (
    primaryStores: { id: string }[],
  ): boolean => {
    return (
      primaryStores.filter((assignedStore) => assignedStore?.id === store.id)
        .length > 0
    );
  };

  const users = (data?.users?.records || []).map((user) => ({
    ...user,
    isPrimary: getIsCurrentStoreAmongPrimary(user.primaryStores || []),
  }));

  const tableConfig = getAssignedOTPsTableConfig({ store, users }, { t });
  const title = `${t('manage-restaurants.otps.assigned', 'Assigned')} (${
    users.length
  })`;

  return (
    <div>
      <Typography className="flex gap-2" variant="subtitle1" fontWeight="bold">
        <MembersAssigned fill="black" />
        {title}
      </Typography>
      <Table
        title=" "
        options={{
          pagination: false,
          sort: false,
          count: users.length,
        }}
        loading={loading}
        data={users}
        columns={tableConfig}
      />
    </div>
  );
};
